var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('Icon',{staticStyle:{"color":"red"},attrs:{"type":"ios-alert-outline","size":"128"}}),_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t("router.noPermission")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }